import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Account, AccountService } from "@rubbl-account";
import { Activity, ActivityService } from "@rubbl-activity";
import { AuthenticationService } from "@rubbl-core";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "app-renter-verification",
  templateUrl: "./renter-verification.component.html",
  styleUrls: ["./renter-verification.component.scss"],
})
export class RenterVerificationComponent implements OnInit {
  activities: Activity[] = [
    this.activityService.getActivityByCode("DRIVERS-LICENSE"),
    this.activityService.getActivityByCode("SELFIE"),
    this.activityService.getActivityByCode("COI"),
    this.activityService.getActivityByCode("TAX-EXEMPTION"),
  ];

  account$ = new Observable<Account>();
  subscriptions = new Subscription();
  constructor(
    private activityService: ActivityService,
    private accountService: AccountService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const accountId = this.authenticationService.getUserNonAsync().profile.account_id;
    this.account$ = this.accountService.get(accountId);
  }

  ngAfterViewInit() {
    this.subscriptions.add(
      this.route.fragment.subscribe(f => {
        const element = document.querySelector("#" + f);
        if (element) {
          element.scrollIntoView();
          window.scrollBy(0, -75);
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
